import React, { Component } from "react";

import { connect } from "react-redux";

import { Creators as Actions } from "ducks/Geral";

import Snackbar from "@material-ui/core/Snackbar";

import {
    NotificationContainer,
    NotificationManager
} from "react-notifications";

class Notificacao extends Component {
    handleHideSnackbar = () => {
        const { setMensagem } = this.props;

        setMensagem({ mostrar: false });
    };

    render() {
        const {
            setErro,
            mensagem,
            exibirMensagem,
            erro,
            exibirErro
        } = this.props;

        return (
            <>
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                    open={exibirMensagem}
                    autoHideDuration={3000}
                    onClose={this.handleHideSnackbar}
                    ContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">{mensagem}</span>}
                />

                {exibirErro &&
                    setErro({ mensagem: null, mostrar: false }) &&
                    NotificationManager.error(erro)}

                <NotificationContainer />
            </>
        );
    }
}

const mapStateToProps = ({ geral }) => {
    const { mensagem, exibirMensagem, erro, exibirErro } = geral;

    return {
        mensagem,
        exibirMensagem,
        erro,
        exibirErro
    };
};

const { setMensagem, setErro } = Actions;

export default connect(mapStateToProps, { setMensagem, setErro })(Notificacao);
